import { Action, createReducer, on } from '@ngrx/store';
import {
  IsUserDeceasedRequest,
  IsUserDeceasedResponse,
  IUserDeceasedUpdateRequest,
  IUserDeceasedUpdateResponse
} from '../models/deceased.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { updateUserAliveRequest, updateUserAliveResponse, updateUserAliveFailure } from '../actions/deceased.actions';

export const aliveFeatureKey = 'alive';

export interface AliveState {
  isAliveRequest: IUserDeceasedUpdateRequest;
  isAliveResponse: IUserDeceasedUpdateResponse;
  isAliveFailure: IGenericError<ErrorResponse>;
}

export const initialState: AliveState = {
  isAliveRequest: undefined,
  isAliveResponse: undefined,
  isAliveFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(updateUserAliveRequest, (state, action) => ({
    ...state,
    isAliveRequest: action.request
  })),
  on(updateUserAliveResponse, (state, action) => ({
    ...state,
    isAliveResponse: action.response
  })),
  on(updateUserAliveFailure, (state, action) => ({
    ...state,
    isAliveFailure: action.error
  }))
);

export const getUserAliveRequest = (state: AliveState) => state.isAliveRequest;
export const getUserAliveResponse = (state: AliveState) => {
  return state.isAliveResponse;
};

export const getUserAliveFailure = (state: AliveState) => state.isAliveFailure;
